const tableCellTypes = {
    COMPONENT: 1
};

export default Object.freeze({
    TABLE_CELL_TYPES: tableCellTypes
});
